/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setIdentityAPIToken } from '../../../config/api';
import { User } from '../../../interfaces/IUser';
import { getGeneralData, postLogin } from './generalDataThunk';
import { GeneralDataState } from './generalDataTypes';

const initialState: GeneralDataState = {
  generalData: undefined,
  generalDataStatus: 'idle',
  loading: false,
  auth: 'LoggedOut',
  usuario: undefined,
  errorMessage: undefined,
};

const generalDataSlice = createSlice({
  name: 'generalData',
  initialState,
  reducers: {
    setLoading: (state: GeneralDataState) => {
      state.loading = true;
    },
    setLoaded: (state: GeneralDataState) => {
      state.loading = false;
    },
    logOut: (state: GeneralDataState) => {
      setIdentityAPIToken('');
      state.auth = 'LoggedOut';
      state.usuario = undefined;
    },
    logIn: (state: GeneralDataState) => {
      setIdentityAPIToken(state.usuario?.accessToken.token ?? '');
      state.auth = 'LoggedIn';
    },
  },
  extraReducers: (buider) => {
    buider.addCase(
      getGeneralData.fulfilled,
      (state: GeneralDataState, action: PayloadAction<string>) => {
        state.generalDataStatus = 'success';
        state.generalData = action.payload;
      }
    );
    buider.addCase(getGeneralData.rejected, (state: GeneralDataState) => {
      state.generalDataStatus = 'error';
    });
    buider.addCase(getGeneralData.pending, (state: GeneralDataState) => {
      state.generalDataStatus = 'pending';
    });
    buider.addCase(
      postLogin.fulfilled,
      (state: GeneralDataState, action: PayloadAction<User>) => {
        state.loading = false;
        state.usuario = action.payload;
      }
    );
    buider.addCase(postLogin.rejected, (state: GeneralDataState, e) => {
      state.loading = false;
      state.errorMessage = e.error.message;
    });
    buider.addCase(postLogin.pending, (state: GeneralDataState) => {
      state.loading = true;
    });
  },
});

export const { setLoaded, setLoading, logIn, logOut } =
  generalDataSlice.actions;

export default generalDataSlice;
